import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import HeroObjectSelector from "TaskDialogCommon/HeroObjectSelector";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import GKMapSelector from "TaskDialogCommon/GKMapSelector";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "gkrun";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        campaign: "",
        chapter: "",
        level: "",
        selectedhero: {},
        usestams: "999",
        noOfHits: "2000",
        speedinsecs: "6",
        poprunes: false,
        troops: {},
        unboxtroops: true,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    const {
      taskConfig: { campaign, chapter, level, selectedhero, noOfHits, troops },
    } = this.state;
    logger.log("validate", this.state);
    if (!selectedhero || Object.keys(selectedhero).length === 0) {
      alert("Please select a hero before continuing");
      return false;
    }
    if (!troops || Object.keys(troops).length === 0) {
      alert("Please select troops to use before continuing");
      return false;
    }
    if (
      !campaign ||
      campaign.length === 0 ||
      !chapter ||
      chapter.length === 0 ||
      !level ||
      level.length === 0
    ) {
      alert("Please select map to hit");
      return false;
    }
    if (noOfHits <= 0) {
      alert("Please increase number of hits to atleast one");
      return false;
    }
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        taskConfig.campaign = storeddata.campaign;
        taskConfig.chapter = storeddata.chapter;
        taskConfig.level = storeddata.level;
        for (var key in accountdetail.heroes) {
          var cityObj = accountdetail.heroes[key];
          for (var hkey in cityObj.cityheroes) {
            var heroObj = cityObj.cityheroes[hkey];
            if (heroObj.heroname === storeddata.selectedhero.heroname) {
              taskConfig.selectedhero = heroObj;
            }
          }
        }
        taskConfig.usestams = storeddata.usestams;
        taskConfig.noOfHits = storeddata.noOfHits;
        taskConfig.speedinsecs = storeddata.speedinsecs;
        taskConfig.poprunes = storeddata.poprunes;
        taskConfig.troops = { ...storeddata.troops };
        taskConfig.unboxtroops = storeddata.unboxtroops;
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    logger.log("event", event, "key", key);
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  setTaskConfigChanges = (taskConfigChanges, callBack) => {
    this.setState(
      (s, p) => ({
        taskConfig: { ...s.taskConfig, ...taskConfigChanges },
      }),
      callBack
    );
  };

  render = () => {
    const {
      setValue,
      setTaskConfigChanges,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;

    logger.log("this.state", this.state);

    return (
      <TaskDialog heading={"GK Run"}>
        <GKMapSelector
          label={"Select Map"}
          taskConfig={taskConfig}
          setValue={setValue}
          setTaskConfigChanges={setTaskConfigChanges}
        />

        <HeroObjectSelector
          label={"Select Hero"}
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"selectedhero"}
        />

        <TaskInput
          label={"Max Stamina To Use"}
          value={taskConfig.usestams}
          onChange={(event) => setValue(event, "usestams")}
        />

        <TaskInput
          label={"No of hits"}
          value={taskConfig.noOfHits}
          onChange={(event) => setValue(event, "noOfHits")}
        />

        <TaskInput
          label={"Hit Speed in secs"}
          value={taskConfig.speedinsecs}
          onChange={(event) => setValue(event, "speedinsecs")}
        />

        <TaskInput
          label={"Auto Pop 200% Runes for mins(Optional)"}
          value={taskConfig.poprunesmins}
          onChange={(event) => setValue(event, "poprunesmins")}
        />

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TroopMapSelector
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Add Troops To Send"}
          param={"troops"}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run GK"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
